import axios from 'axios';
import { FilterSelectedValue } from '../hooks/filters/interfaces/filter-selected-value.interface';
import {
  Filter,
  FilterOptions,
} from '../hooks/filters/interfaces/filter.interface';

const API_URL = process.env.REACT_APP_API_URL;

export const getFiltersService = async (
  filterSelection?: FilterSelectedValue[] | undefined,
): Promise<Filter[]> => {
  const data = (
    await axios.get(`${API_URL}filters`, {
      data: { filterSelection },
      params: {},
    })
  ).data;
  return data;
};
export const getFilterOptionsService = async (
  id: string,
  filterSelection?: (FilterSelectedValue | undefined)[],
  s?: string | undefined | null,
): Promise<FilterOptions> => {
  const search = s === null ? undefined : s;
  return (
    await axios.get(`${API_URL}filters/options`, {
      params: { id, search },
      data: { filterSelection },
    })
  ).data;
};

const filterSelections: Record<string, FilterSelectedValue> = {};
export const setValue = (selectedValue: FilterSelectedValue) => {
  //console.log("SET VALUE", selectedValue)

  filterSelections[selectedValue.id] = selectedValue;
  return selectedValue;
};
export const getValue = (id: string) => {
  //console.log("getValue", id, filterSelections[id])
  return filterSelections[id];
};
export const getFilterSelectedValueService = async (
  id: string,
): Promise<FilterSelectedValue | undefined> => {
  const val = getValue(id);
  if (val === undefined) {
    const data = (
      await axios.get(`${API_URL}filters/selected-value`, { params: { id } })
    ).data;
    setValue(data);
    return data;
  } else {
    return val;
  }
};

export const setFilterSelectedValueService = async (
  selectedValue: FilterSelectedValue,
): Promise<FilterSelectedValue> => {
  setValue(selectedValue);
  //axios.post(`${API_URL}filters/selected-value`, { selectedValue }, { params: { id: selectedValue.id } });
  return selectedValue;
};
